import React from 'react';

const GraphDateSelector = (props) => {
  const { libelle, handlePreviousMonth, handleNextMonth } = props;

  return (
    <div className="graph-date-selector-container">
      <div onClick={handlePreviousMonth}><i className="cell-render-icon-circle-background fas fa-chevron-left color-fond-vert"/></div>
      <p>{libelle}</p>
      <div onClick={handleNextMonth}><i className="cell-render-icon-circle-background fas fa-chevron-right color-fond-vert"/></div>
    </div>
  );

};

export default GraphDateSelector;